import MojitoModules from 'mojito/modules';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;
export function getMarketsConfig() {
    return {
        custom: {
            [PALETTE_IDS.MARKETS]: {
                AggregatedMarket: {
                    expandable: {
                        rightIconTooltip: '$CASHOUT.TOOLTIP',
                    },
                },
                GameLineMarketContent: {
                    selectionNameDisplay: {
                        TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT,
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.MARKETS]: {
                MARKETS_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                MARKETS_CONTAINER_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                MARKETS_SELECTION_HEADER_LABEL_TEXT: {
                    fontSize: FONT.SIZE_SMALL,
                    color: COLOR.BRAND.FOREGROUND4,
                },
                MARKETS_PLAYER_NAME_TEXT: COLOR.BRAND.FOREGROUND4,
                MARKETS_TEAM_NAME_TEXT: COLOR.BRAND.FOREGROUND6,

                MARKETS_PRICE_BOOST_ITEM: {
                    PBI_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND6,
                    PBI_SELECTION_NAME_TEXT: COLOR.BRAND.FOREGROUND4,
                    PBI_PREVIOUS_PRICE_CVI: {
                        CVI_PREVIOUS_VALUE_TEXT: COLOR.BRAND.FOREGROUND6,
                    },
                },
                MARKETS_SHOW_HIDE_ALL_BUTTON_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    color: COLOR.BRAND.FOREGROUND4,
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontStyle: 'italic',
                },
                MARKETS_SHOW_HIDE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND4,

                MARKETS_SKELETON_CONTAINER_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                MARKETS_CONTAINER_HEADER_BET_BUILDER_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MARKETS_CONTAINER_HEADER_CASHOUT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MARKETS_CORRECT_SCORE_PARTICIPANTS: {
                    PARTICIPANTS_TEXT: {
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },
                MARKETS_CONTAINER_HEADER_EARLY_PAYOUT_INDICATOR: {
                    EARLY_PAYOUT_INDICATOR_LABEL: {
                        BET_BONUS_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
                    },
                },
                MARKETS_HANDICAP_RANGE_INPUT: {
                    RANGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND4,
                },
            },
        },
    };
}
